<template>
  <div>
    <h1>Editar origen</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Nombre del origen">
                <a-input ref="name" placeholder="Nombre del origen" v-model="$v.origin.name.$model" />
                <small class="text-danger" v-if="!$v.origin.name.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!validateRegisteredSource($v.origin.name.$model)">Ya existe un registro con este nombre de origen</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Geocerca">
                <v-select label="name" :options="getAllGeofences" v-model="$v.origin.geofence.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.origin.geofence.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!(validateRegisteredSource($v.origin.name.$model) && !$v.$invalid)">
                  Actualizar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { required } from 'vuelidate/lib/validators'
import headers from '@/config/headers.js'
const GET_ALL_GEOFENCES = gql`
  query getAllGeofences{
    getAllGeofences{
      id
      name
    }
  }
`
const GET_ALL_SOURCES = gql`
  query getAllSources{
    getAllSources{
      id
      name
      createdBy
    }
  }
`
const UPDATE_SOURCE = gql`
  mutation updateSource($sourceId: Int, $name: String, $geofenceId: Int){
    updateSource(sourceId: $sourceId sourceRequest: { name: $name geofenceId: $geofenceId }){
      id
      name
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      origin: {
        name: this.$route.params.name,
        geofence: this.$route.params.geofence,
      },
      createdBy: this.$store.state.user.email,
      registeredSources: {},
      getAllGeofences: [],
    }
  },
  apollo: {
    getAllGeofences: {
      query: GET_ALL_GEOFENCES,
      result({ data }) {
        // console.log(data)
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
    getAllSources: {
      query: GET_ALL_SOURCES,
      context: headers(),
      result({ data }) {
        data.getAllSources.forEach(source => {
          this.registeredSources[source.name] = 1
        })
        // console.log('registeredSources')
        delete this.registeredSources[this.origin.name]
      },
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$apollo.mutate({
        mutation: UPDATE_SOURCE,
        context: headers(),
        variables: {
          sourceId: parseInt(this.$route.params.id),
          name: this.origin.name,
          geofenceId: parseInt(this.origin.geofence.id),
        },
      })
        .then(data => {
          console.log(data)
          this.$router.push('/tarifasPlanas/origen')
        })
        .catch(error => {
          console.log(error)
        })
    },
    validateRegisteredSource(sourceName) {
      if (this.registeredSources[sourceName.trim()]) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    // console.log(this.$route.params)
  },
  validations: {
    origin: {
      name: { required },
      geofence: { required },
    },
  },
}
</script>
